import { combineReducers } from 'redux';

import adviceHistory from './adviceHistory';
import byId from './byId';
import byType from './byType';

const data = combineReducers({
  byId,
  byType,
  adviceHistory,
});

export type ChecklistDataReducer = ReturnType<typeof data>;

export default data;
